import { useMutation } from '@tanstack/react-query'
import axios from 'axios'
import { convertCaseList, ConvertType } from 'utils/convertString'

interface IKDCApplyProps {
  courseId: string
  kdcAttrId: string
  userId: number | undefined
  appliedAt?: string
  gclid?: string
  hrdInfo?: { haveCardAt?: string; haveNoCardAt?: string }
}

const updateKDCApply = async (data: IKDCApplyProps) => {
  const resp = await axios.post(
    `${window.apiEndpoint}/my/course/v1/kdc-applies`,
    convertCaseList(data, ConvertType.SNAKE),
  )

  return convertCaseList(resp, ConvertType.CAMEL)
}

export const useKDCApplyMutation = () => useMutation(updateKDCApply)
